var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownArrowBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 6,
    viewBox: "0 0 13 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7132 0.219052L6.33818 3.71905L1.96318 0.219052C1.86062 0.136976 1.7429 0.0759048 1.61673 0.0393253C1.49057 0.00274569 1.35843 -0.00862582 1.22787 0.00586012C1.09732 0.0203461 0.970888 0.0604056 0.855811 0.123752C0.740733 0.187098 0.63926 0.27249 0.557184 0.375052C0.475107 0.477615 0.414036 0.595339 0.377457 0.721503C0.340877 0.847668 0.329506 0.979802 0.343992 1.11036C0.358477 1.24092 0.398537 1.36735 0.461883 1.48242C0.525229 1.5975 0.610621 1.69898 0.713184 1.78105L5.71318 5.78105C5.89055 5.92306 6.11098 6.00043 6.33818 6.00043C6.56539 6.00043 6.78582 5.92306 6.96318 5.78105L11.9632 1.78105C12.1703 1.61529 12.3031 1.37404 12.3324 1.11036C12.3616 0.846685 12.2849 0.582186 12.1192 0.375052C12.0371 0.27249 11.9356 0.187098 11.8206 0.123752C11.7055 0.0604056 11.5791 0.0203461 11.4485 0.00586012C11.1848 -0.0233956 10.9203 0.053292 10.7132 0.219052Z",
    fill: "#056EE6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrowBlue);
export default __webpack_public_path__ + "static/media/downArrowBlue.2aec67b42a23bef3a80ffcb038ad5499.svg";
export { ForwardRef as ReactComponent };